import { Th, THead, Tr } from '@twilio-paste/core/table';

export function TargetAuthHeaderTableHeader() {
  return (
    <THead>
      <Tr>
        <Th>Auth Header</Th>
        <Th>Auth Value</Th>
        <Th></Th>
      </Tr>
    </THead>
  );
}
